import React, { ReactElement, ReactText } from 'react';
import { View } from 'react-native';
import { isElement } from 'react-is';
import { Title3, Caption1 } from 'src/components/Typography';
import { PlatformPadding } from 'src/components/PlatformPadding';
import useStyles from './GroupHeader.styles';

export type GroupHeaderProps = {
  variant?: 'primary' | 'secondary';
  aside?: ReactElement;
  subtitle?: string;
  indicator?: ReactText | ReactElement;
};

export const GroupHeader: React.FC<GroupHeaderProps> = ({
  variant = 'primary',
  aside,
  subtitle,
  indicator,
  children,
}) => {
  const s = useStyles({ variant });

  return (
    <PlatformPadding horizontal>
      <View style={s.root}>
        <View>
          <View style={s.main}>
            {variant === 'primary' && <Title3 weight="semibold">{children}</Title3>}
            {variant === 'secondary' && (
              <Caption1 uppercase style={s.text}>
                {children}
              </Caption1>
            )}
            <View style={s.indicator}>
              {indicator &&
                (isElement(indicator) ? (
                  indicator
                ) : (
                  <Caption1 style={s.indicatorText}>{indicator}</Caption1>
                ))}
            </View>
          </View>
          {subtitle && variant === 'primary' && <Caption1 style={s.subtitle}>{subtitle}</Caption1>}
        </View>
        {aside}
      </View>
    </PlatformPadding>
  );
};
